import UsedCoupon from "pages/Admin/ManageCoupen/UsedCoupon";
import { CoupenList } from "../../../pages";
import adminRouteMap from "../../../routeControl/adminRouteMap";

export default function route() {
  return [
    {
      path: adminRouteMap.MANAGE_COUPEN.path,
      name: "Coupon List",
      key: adminRouteMap.MANAGE_COUPEN.path,
      private: true,
      belongsToSidebar: true,
      icon: adminRouteMap.MANAGE_COUPEN.icon,

      element: <CoupenList />,
    },
    {
      path: `${adminRouteMap.USED_COUPON.path}/:id`,
      name: "Coupon Details",
      key: `${adminRouteMap.USED_COUPON.path}/:id`,
      private: true,
      element: <UsedCoupon />,
    },
  ];
}
